import { createFileRoute } from '@tanstack/react-router'
import { useOrganization } from '@/pages/organizations/detail'
import { useReports } from '@/pages/organizations/detail/reports'
import ChildrenOfTypeSetPage from '@/features/reports/components/pages/ChildrenOfTypeSetPage'

export const Route = createFileRoute(
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/sets/$setId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { childOrgTypeMachineName, setId } = Route.useParams()
  const { organization } = useOrganization()
  const { userCanViewAssessmentsChild, userCanViewResponsesChild } = useReports()

  return (
    <ChildrenOfTypeSetPage
      organization={organization}
      childOrgTypeMachineName={childOrgTypeMachineName}
      setId={Number(setId)}
      userCanViewAssessmentsChild={userCanViewAssessmentsChild}
      userCanViewResponsesChild={userCanViewResponsesChild}
    />
  )
}
